import { createSlice } from '@reduxjs/toolkit';

const usersSlice = createSlice({
  name: "users",
  initialState: {
    currentUser: null,
    loading: true
  },
  reducers: {
    setUser: (state, action) => {
      state.currentUser = action.payload;
      state.loading = false;
    },
    clearUser: (state) => {
      state.currentUser = null;
      state.loading = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
})

export const { setUser } = usersSlice.actions;
export const {clearUser} = usersSlice.actions;
export const {setLoading} = usersSlice.actions;


export const selectUsers = state => state.users;

export default usersSlice.reducer;